// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"8":"5102c596dc7a77e2","888":"efa227bdbe00704c"}[chunkId] + ".css";
};